import React, { useState } from 'react';
import { ArrowRightIcon, InstagramIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { GlowFrame } from './GlowFrame';
import { FormModal } from './FormModal';
import type { FormFieldConfig } from '../types/contact';
const ENQUIRY_CARDS = [{
  type: 'Venues & Festivals',
  description: 'Bring the full production to your stage.'
}, {
  type: 'Special Events & Partners',
  description: 'Co-productions, sponsorships and collaborations.'
}, {
  type: 'Media',
  description: 'Press access, interviews and coverage.'
}];
const ENQUIRY_FIELDS: FormFieldConfig[] = [{
  id: 'name',
  label: 'Name',
  type: 'text',
  required: true,
  maxLength: 100
}, {
  id: 'organisation',
  label: 'Organisation',
  type: 'text',
  required: true,
  maxLength: 150
}, {
  id: 'contact',
  label: 'Contact information',
  type: 'text',
  required: true,
  placeholder: 'Email, phone, or preferred contact method',
  maxLength: 200
}, {
  id: 'message',
  label: 'Message',
  type: 'textarea',
  required: true,
  helperText: 'Feel free to add more contact information below',
  maxLength: 2000
}, {
  id: 'source',
  label: 'Source / referral',
  type: 'text',
  placeholder: 'How did you hear about us?',
  maxLength: 200
}];
export function ContactSection() {
  const [enquiryType, setEnquiryType] = useState<string | null>(null);
  return <section id="contact" aria-label="Contact" className="bg-ink px-5 py-24 sm:px-8 lg:px-12 lg:py-32" data-id="element-46" data-mp="qjz543rcw79i">
      <div className="mx-auto max-w-5xl" data-id="element-47" data-mp="lkw7v5hmb5c3">
        <Reveal data-id="element-48" data-mp="lk3b8xcdhw7o">
          <h2 className="mb-14 text-center font-heading text-4xl uppercase leading-tight tracking-tight text-led sm:text-5xl lg:text-6xl" data-id="element-49" data-mp="10akdgiwu0q5m">
            The Doors of Perception in your city
          </h2>
        </Reveal>

        <div className="grid gap-6 sm:grid-cols-3" data-id="element-50" data-mp="19aqnfutbn801">
          {ENQUIRY_CARDS.map((card, index) => <Reveal key={card.type} delay={index * 0.1} data-id="element-51" data-mp="14d6yo0yzzctu" data-mpi={index}>
              <GlowFrame as="button" interactive onClick={() => setEnquiryType(card.type)} className="group flex h-full min-h-[16rem] w-full flex-col justify-between p-6 text-left" data-id="element-52" data-mp="14akqq0872vb3">
                <p className="font-heading text-xl uppercase tracking-tight text-led" data-id="element-53" data-mp="ayw6om5v3ty0">{card.type}</p>
                <div data-id="element-54" data-mp="fryzut6q91do">
                  <p className="mb-4 text-sm text-led/60" data-id="element-55" data-mp="fsikihnri3ve">{card.description}</p>
                  <ArrowRightIcon className="h-5 w-5 text-led/55 transition-transform duration-300 group-hover:translate-x-1 group-hover:text-ice" aria-hidden="true" data-id="element-56" data-mp="koz4cznxhw2o" />
                </div>
              </GlowFrame>
            </Reveal>)}
        </div>

        <Reveal delay={0.2} data-id="element-57" data-mp="yn5v7vugmvsu">
          <div className="mt-14 flex flex-col items-center gap-4 text-center" data-id="element-58" data-mp="2wfb9qk0ictan">
            <p className="border-b border-ice/50 pb-2 text-sm tracking-[0.12em] text-led" aria-label="dop2026live at gmail dot com" data-id="element-59" data-mp="2whe9hvrgq0sk">
              <span data-id="element-60" data-mp="2syf3r8ja0gf7">dop2026live</span>
              <span aria-hidden="true" data-id="element-61" data-mp="2o6nohu5klx4d">@</span>
              <span data-id="element-62" data-mp="2o4uf473koyso">gmail.com</span>
            </p>
            <a href="https://www.instagram.com/doorsofperceptionlive" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 text-sm tracking-[0.08em] text-led/60 transition-colors duration-300 hover:text-ice focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice" data-id="element-63" data-mp="2j719pga3g8tg">
              <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-64" data-mp="32va1hp7q6csf" />
              @doorsofperceptionlive
            </a>
          </div>
        </Reveal>
      </div>

      <FormModal isOpen={enquiryType !== null} onClose={() => setEnquiryType(null)} title={enquiryType ? `${enquiryType} Enquiry` : 'Enquiry'} requestType={enquiryType || 'Media'} fields={ENQUIRY_FIELDS} submitLabel="Send enquiry" data-id="element-65" data-mp="2xvozt7167qc0" />
    </section>;
}